const KEY = "bsmeet.client-id";

function fresh(): string {
  const random = globalThis.crypto?.randomUUID?.();
  if (random !== undefined) return random;
  return `c-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}

let cached = "";

export function clientId(): string {
  if (cached !== "") return cached;
  try {
    const stored = globalThis.sessionStorage.getItem(KEY);
    if (stored !== null && stored !== "") {
      cached = stored;
      return cached;
    }
    cached = fresh();
    globalThis.sessionStorage.setItem(KEY, cached);
    return cached;
  } catch {
    cached = fresh();
    return cached;
  }
}
